import React, {useState, useEffect} from 'react'
import axios from 'axios'
import { Situation } from './Situation'
import Answer from './Answer'

export const Test = (props) => {
  const [token, setToken] = useState(props.token)
  const [status, setStatus] = useState("pending")
  const [items, setItems] = useState([])

  const[activeItem, setActiveItem] = useState(null);

  const removeActiveItem=()=>{
    const item = items.find(item => item.Id === activeItem.Id);
    item.Answered= true;
    setActiveItem(null);
    checkStatus();
  }

  const checkStatus=()=>{
    const answeredItems = items.filter(item => item.Answered == true);
    if(answeredItems.length == items.length){
      window.location.href = '/testcompletion';
    }
  }

  useEffect(()=>{
    if(status == "pending"){
      getAssessments();
    }
  });

  const nextSituation=()=>{
   

  }

  const previousSituation=()=>{
   
  }

  const getAssessments=()=>{
    axios.get('/assessment/situations?id=' + token)
    .then(function (response) {
        if(response.data.status == "completed"){
          setStatus(response.data.status);
          window.location.href = '/testcompletion';
        }
        else{
          setStatus(response.data.status);
          setItems(response.data.data);
        }
    })
    .catch(function (error) {
      console.error(error);
    });
  }

  if(activeItem == null){
    return (
      <div className="situations">
        <div className="alert alert-warning">You have {props.days} days remaining</div>
        <div className="row" id="slides">
            {items.map((item,index)=>{
                return <div key={item.Id} className="col-sm-6 col-md-6 col-lg-3"><Situation {...item} setActiveItem={setActiveItem} /></div>
              })}
        </div>
      </div>
    )
  }
  else{
    return (
      <Answer {...activeItem} setActiveItem={setActiveItem} removeActiveItem={removeActiveItem} nextSituation={nextSituation} previousSituation={previousSituation} />
    )
  }
}
